import { getStoreId } from "$/hooks/use-store-information"
import companyQueries from "$/lib/queries/company-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/companies/")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(companyQueries.list(storeId))
  },
})
